export default __webpack_public_path__ + "static/media/Herman Heitmann Arraes.8aa43492.png";